import { Domain } from './dataAccessTypes.js';

export type EntityType =
  | 'users'
  | 'roleDefinitions'
  | 'userFarmMemberships'
  | 'farms'
  | 'tasks'
  | 'transactions'
  | 'documents'
  | 'messages'
  | 'links'
  | 'mapFeatures'
  | 'assets'
  | 'projects'
  | 'workLogs'
  | 'gpsTrackPoints'
  | 'scoutingPhotos'
  | 'scoutingPhotoCategories';

export const ENTITY_DOMAIN: Record<EntityType, Domain> = {
  users: 'settings',
  roleDefinitions: 'settings',
  userFarmMemberships: 'settings',
  farms: 'map',
  tasks: 'maintenance',
  transactions: 'finances',
  documents: 'docs',
  messages: 'docs',
  links: 'docs',
  mapFeatures: 'map',
  assets: 'assets',
  projects: 'maintenance',
  workLogs: 'maintenance',
  gpsTrackPoints: 'gps',
  scoutingPhotos: 'scouting',
  scoutingPhotoCategories: 'scouting',
};

export const ENTITY_PRIMARY_KEYS: Record<EntityType, string> = {
  users: 'email',
  roleDefinitions: 'role',
  userFarmMemberships: 'membership_id',
  farms: 'farm_id',
  tasks: 'task_id',
  transactions: 'transaction_id',
  documents: 'document_id',
  messages: 'message_id',
  links: 'record_link_id',
  mapFeatures: 'map_feature_id',
  assets: 'asset_id',
  projects: 'id',
  workLogs: 'id',
  gpsTrackPoints: 'id',
  scoutingPhotos: 'photo_id',
  scoutingPhotoCategories: 'category_id',
};

const DEXIE_FIRST_ENTITIES: EntityType[] = ['farms', 'mapFeatures', 'gpsTrackPoints'];

export const isDexieEntity = (entity: EntityType) => DEXIE_FIRST_ENTITIES.includes(entity);

export const isDexieDomain = (domain: Domain) => domain === 'gps';

export const getDomainForEntity = (entity: EntityType): Domain => ENTITY_DOMAIN[entity];

export const getRepositoryKind = (entity: EntityType): 'dexie' | 'server' =>
  isDexieEntity(entity) ? 'dexie' : 'server';

export const getEntityMetadata = (entity: EntityType) => ({
  domain: getDomainForEntity(entity),
  primaryKey: ENTITY_PRIMARY_KEYS[entity],
  repositoryKind: getRepositoryKind(entity),
});
